import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/login',
    name: 'login',
    alias: "/",
    component: () => import('./views/Login.vue'),
    meta: {
      requiresAuth: false,
      title: 'Seaprojects - Login',
    }
  },
  {
    path: "/SSO",
    name: "SSO",
    component: () => import("./views/SSO.vue"),
    meta: {
      requiresAuth: false,
      showMessage: false,
      title: "Seaprojects - Signing In",
    },
  },
  {
    path: '/requirements',
    name: 'requirements',
    alias: "/",
    component: () => import('./views/Requirements.vue'),
    meta: {
      requiresAuth: false,
      title: 'Seaprojects - Requirements',
    }
  }, {
    path: '*',
    redirect: '/login'
  }],
});

router.beforeEach(async (to, from, next) => {

  if (to.name == "login" && to.query.sso) {
    window.location.href = `${process.env.VUE_APP_SEAHUB_URL}?redirect=${process.env.VUE_APP_URL}/sso`;
  }

  if (to.name == "SSO") {
    await store.dispatch("authenticate");
    isAuthorized = store.getters.getAuthorized;
    if (isAuthorized) {
      next("requirements");
    } else {
      next();
    }
    return;
  }

  var isLoggedIn = localStorage.getItem("loggedIn");
  var isAuthorized = isLoggedIn ? store.getters.getAuthorized : false;
  if (!isAuthorized && isLoggedIn) {
    await store.dispatch("authenticate");
    isAuthorized = store.getters.getAuthorized;
  }
  if (isAuthorized && to.name == "login") {
    next("requirements");
  } else {
    next();
  }

});



export default router;